import { OnboardingQuestion, QuestionAnswer, } from 'common/types';
import { makeAutoObservable } from 'mobx';

class OnboardingStore {
    

    isValidEmail = true
    enabled = false
    isValidUrl = true
    fileName: string
    previewImage: string
    previewBanner: string
    avatarUpdated = false
    updateButtonEnabled = false
    editProfileQuestions: OnboardingQuestion[]
    showPartner: boolean = location.pathname?.includes('partner') || location.pathname?.includes('company') ? true : false
    companyNameError = false
    companyEmailError = false
    isUSOrCanada = false

    constructor() {
        makeAutoObservable(this);
    }
    
     setEnabled = (enabled: boolean) => {
        this.enabled = enabled
    }
     setIsValidEmail = (isValidEmail: boolean) => {
        this.isValidEmail = isValidEmail
    }
     setIsValidUrl = (isValidUrl: boolean) => {
        this.isValidUrl = isValidUrl
    }
     setFileName = (fileName: string) => {
        this.fileName = fileName
    }
     setPreviewImage = (previewImage: string) => {
        this.previewImage = previewImage
    }
     setPreviewBanner = (previewBanner: string) => {
        this.previewBanner = previewBanner
    }
     setAvatarUpdated = (avatarUpdated: boolean) => {
        this.avatarUpdated = avatarUpdated
    }
     setUpdateButtonEnabled = (updateButtonEnabled: boolean) => {
        this.updateButtonEnabled = updateButtonEnabled
    }
     setEditProfileQuestions = (editProfileQuestions: OnboardingQuestion[]) => {
        this.editProfileQuestions = editProfileQuestions
    }
     setShowPartner = (showPartner: boolean) => {
        this.showPartner = showPartner
    }
     setCompanyNameError = (companyNameError: boolean) => {
        this.companyNameError = companyNameError
    }
     setCompanyEmailError = (companyEmailError: boolean) => {
        this.companyEmailError = companyEmailError
    }
    setIsUSOrCanada = (isUSOrCanada: boolean) => {
        this.isUSOrCanada = isUSOrCanada
    }
}

export const onboardingStoreState = new OnboardingStore();
